import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest } from '@angular/common/http';
//import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/map';
import { map ,delay} from 'rxjs/operators';

import { AppGlobals } from '../shared/app.global';

@Injectable({
  providedIn: 'root'
})
export class HrmsService {

  callurl: string = '';
  
  clcd:string;
  aycd:string;
  usid:string;
  
      constructor(private http: HttpClient,private _global: AppGlobals) {
  
         this.clcd=localStorage.getItem('clcd');
         this.aycd=localStorage.getItem('aycd');
         this.usid=localStorage.getItem('usid');
       
         this.callurl=_global.baseAPIUrl;
       }

       
       getdatetoday()
       {
        let d: Date = new Date();
        var mnth;
        var day='';
        //let todayDate = {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};
        if(d.getMonth()>=10)
        {
          mnth=d.getMonth()+1;
        }
        else{
         // mnth='0'+d.getMonth()+1;
         mnth=d.getMonth()+1;
         mnth='0'+mnth;
        }
     
        if(d.getDate()>=10)
        {
          day=d.getDate().toString();
        }
        else{
          day='0'+d.getDate();
        }
        let todayDate =  d.getFullYear()+'-'+ mnth+'-' +day;
          
     return todayDate;
     
       }

       getemployes(): Observable<any> {
        debugger
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');libsubjectgroup
        
        return this.http.post(this.callurl + 'selemploys',{clcd:this.clcd,aycd:this.aycd})
        .pipe(map((data: any) => {
                console.log('retres-data', data);
                return data;
                
            }));
      }


      resetpassword(emid): Observable<any> {
        debugger
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');libsubjectgroup
        
        return this.http.get(this.callurl + 'resetempassword/'+this.clcd+'/'+this.aycd+'/'+emid)
        .pipe(map((data: any) => {
                console.log('retres-data', data);
                return data;
                
            }));
      }

      changerole(emid,rlid): Observable<any> {
        debugger
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');libsubjectgroup
        
        return this.http.get(this.callurl + 'changerole/'+this.clcd+'/'+this.aycd+'/'+emid+'/'+rlid)
        .pipe(map((data: any) => {
                console.log('retres-data', data);
                return data;
                
            }));
      }

      resetstupassword(emid,tag): Observable<any> {
        debugger
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');libsubjectgroup
        
        return this.http.get(this.callurl + 'resetstupassword/'+this.clcd+'/'+this.aycd+'/'+emid+'/'+tag)
        .pipe(map((data: any) => {
                console.log('retres-data', data);
                return data;
                
            }));
      }

      hrsubjectallocation(): Observable<any> {
        debugger
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');libsubjectgroup
        
        return this.http.get(this.callurl + 'sel_sp_hrsuballocation/Subject/'+this.clcd+'/'+this.aycd)
        .pipe(map((data: any) => {
                console.log('retres-data', data);
                return data.sp_hrsuballot;
                
            }));
      }

      selstaffbyclass(clid,crid,scid): Observable<any> {
        debugger
        let clcd=localStorage.getItem('clcd');
        let aycd=localStorage.getItem('aycd');
        
        // var api=this.callurl + 'selstaffbyclass/'+clid+'/'+scid+'/'+crid+'/'+this.clcd+'/'+this.aycd;
        
        return this.http.get(this.callurl + 'selstaffbyclass/'+clid+'/'+scid+'/'+crid+'/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
                console.log('retres-data', data);
                return data.sp_hrsuballot;
                
            }));
      }
      savehrmsubalot(objsubalot): Observable<any> {
        debugger
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');libsubjectgroup
        objsubalot.clcd=this.clcd;
        objsubalot.aycd=this.aycd;
        objsubalot.usid=this.usid;
        
        return this.http.post(this.callurl + 'save_sp_hrsuballocation',objsubalot)
        .pipe(map((data: any) => {
                console.log('retres-data', data);
                return data;
                
            }));
      }

      hrclassteacher(): Observable<any> {
        debugger
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');libsubjectgroup
        
       // return this.http.get(this.callurl + 'sel_sp_classteacher/'+this.clcd+'/'+this.aycd)
       return this.http.get(this.callurl + 'sel_sp_hrsuballocation/Incharge/'+this.clcd+'/'+this.aycd)
        .pipe(map((data: any) => {
                console.log('retres-data', data);
                return data.sp_hrsuballot;
               
                
            }));
      }


      paycategory(): Observable<any> {
        
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');libsubjectgroup
        
        return this.http.get(this.callurl + 'selpaycategory/'+this.clcd+'/'+this.aycd)
        .pipe(map((data: any) => {
                console.log('arrpaycat', data);
                return data.arrpaycat;
                
            }));
      }

      empcategory(): Observable<any> {
        
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');libsubjectgroup
        
        return this.http.get(this.callurl + 'selempcategory/'+this.clcd+'/'+this.aycd)
        .pipe(map((data: any) => {
                console.log('arrpaycat', data);
                return data.arrempcat;
                
            }));
      }

      selemploy_details(emid): Observable<any> {
        
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');libsubjectgroup
        
        return this.http.get(this.callurl + 'selemploy_details/'+this.clcd+'/'+this.aycd+'/'+emid)
        .pipe(map((data: any) => {
                console.log('arrpaycat', data);
                return data;
                
            }));
      }
      savehrclassteacher(objsubalot): Observable<any> {
        debugger
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');libsubjectgroup
        objsubalot.clcd=this.clcd;
        objsubalot.aycd=this.aycd;
        objsubalot.usid=this.usid;
        
        return this.http.post(this.callurl + 'save_sp_classteacher',objsubalot)
        .pipe(map((data: any) => {
                console.log('retres-data', data);
                return data;
                
            }));
      }


      saveemployee(objsubalot): Observable<any> {
        debugger
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');libsubjectgroup
        objsubalot.clcd=this.clcd;
        objsubalot.aycd=this.aycd;
        objsubalot.usid=this.usid;
        
        return this.http.post(this.callurl + 'save_hrmemployee',objsubalot)
        .pipe(map((data: any) => {
                console.log('retres-data', data);
                return data;
                
            }));
      }


      uploadphoto(data: File,bkid): Observable<any> {
        /// this._url = 'http://localhost:4200/XXXXXXXXXX/uploadFile';
      debugger
        const formData: FormData = new FormData();
        console.log("stuid",bkid)
        formData.append('Image', data, data.name);
          
          formData.append('emid', bkid);
          
          formData.append('clcd', this.clcd);
          formData.append('aycd', this.aycd);
          formData.append('crby', this.usid);
          console.log("formData",formData);
         return this.http.post(this._global.baseAPIUrl + 'uploadempphoto', formData)
         .pipe(map((data: any) => {
             console.log('retres', data);
             return data
         }));
      }
  

      selhrmworkdairy(objsubalot): Observable<any> {
        debugger
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');libsubjectgroup
        objsubalot.clcd=this.clcd;
        objsubalot.aycd=this.aycd;
        objsubalot.usid=this.usid;
        
        return this.http.post(this.callurl + 'selhrmworkdairy',objsubalot)
        .pipe(map((data: any) => {
                console.log('retres-data', data);
                return data.hrmworkdairy;
                
            }));
      }


      selhrmworkdairywithatt(objsubalot): Observable<any> {
        debugger
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');libsubjectgroup
        objsubalot.clcd=this.clcd;
        objsubalot.aycd=this.aycd;
        objsubalot.usid=this.usid;
        
        return this.http.post(this.callurl + 'selworkattconsolid',objsubalot)
        .pipe(map((data: any) => {
                console.log('retres-data', data);
                return data.hrmworkdairy;
                
            }));
      }

      selworklist(objsubalot): Observable<any> {
        debugger
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');libsubjectgroup
        objsubalot.clcd=this.clcd;
        objsubalot.aycd=this.aycd;
        objsubalot.usid=this.usid;
        
        return this.http.post(this.callurl + 'selworkdairylist',objsubalot)
        .pipe(map((data: any) => {
                console.log('retres-data', data);
                return data.hrmworkdairy;
                
            }));
      }

      
      savehrmworkdairy(objsubalot): Observable<any> {
        debugger
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');libsubjectgroup
        objsubalot.clcd=this.clcd;
        objsubalot.aycd=this.aycd;
        objsubalot.usid=this.usid;
        
        return this.http.post(this.callurl + 'savehrmworkdairy',objsubalot)
        .pipe(map((data: any) => {
                console.log('retres-data', data);
                return data;
                
            }));
      }
}
